import React from 'react'
import TitleText from '../utils/TitleText'
import HomeButton from '../components/homebutton/HomeButton'  
const NotFound = () => {
  TitleText('404 : Not Found !')
  return (
    
    <div>
      <HomeButton/>
       <h2>
       404 Not Found ! 
       </h2>
        </div>
  )
}

export default NotFound